import { render, staticRenderFns } from "./NolaNovelDelinkConfirm.vue?vue&type=template&id=8c5bcfcc&scoped=true&"
import script from "./NolaNovelDelinkConfirm.vue?vue&type=script&lang=ts&"
export * from "./NolaNovelDelinkConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./NolaNovelDelinkConfirm.vue?vue&type=style&index=0&id=8c5bcfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5bcfcc",
  null
  
)

export default component.exports